import type { AppContext } from "@/types/scheduling";
import { communicationStyles, nutritionAreas, paymentMethods, usaStates } from "@/utils/constants";
import { insuranceList } from "shared/constants";
import type { InsuranceValue, PaymentType } from "shared/types";
import { LeadEmailSchema, LeadNameSchema, LeadPhoneNumberSchema } from "shared/validations";
import { safeParse } from "valibot";

export const handleValidInput = <T extends AppContext>(context: T, params: { key: string }) => {
  if (params.key === "nutrition_area") {
    return nutritionAreas.map(({ value }) => value).includes(context.result.nutrition_area.value);
  }
  if (params.key === "state") {
    return usaStates.map(({ value }) => value).includes(context.result.state.value);
  }
  if (params.key === "day") {
    return context.result.day.value !== "";
  }
  if (params.key === "communication_style") {
    return communicationStyles.map(({ value }) => value).includes(context.result.communication_style.value);
  }
  if (params.key === "payment_method") {
    return paymentMethods.map(({ value }) => value).includes(context.result.payment_method.value as PaymentType)
  }
  if (params.key === "insurance_provider") {
    return insuranceList.map(({ value }) => value).includes(context.result.insurance_provider?.value as InsuranceValue)
  }
  // TODO unify with validNext
  if (params.key === "insurance_provider_other") {
    return !!context.result.insurance_provider_other && context.result.insurance_provider_other !== "" &&
      context.result.insurance_provider_other?.length > 1 &&
      context.next_allowed.insurance_selection_other
  }
  if (params.key === "lead_name") {
    const result = safeParse(LeadNameSchema, context.result.lead_name)
    return result.success && context.next_allowed.lead_name
  }
  if (params.key === "lead_email") {
    const result = safeParse(LeadEmailSchema, context.result.lead_email)
    return result.success && context.next_allowed.lead_email
  }
  if (params.key === "lead_phone_number") {
    const result = safeParse(LeadPhoneNumberSchema, context.result.lead_phone_number)
    return result.success && context.next_allowed.lead_phone_number
  }
  return false;
}